var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.25,
    height: 19.117,
    viewBox: "0 0 26.25 19.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 1.25px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10127",
    "data-name": "Group 10127",
    transform: "translate(19335.625 20728.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7139",
    "data-name": "Path 7139",
    className: "cls-1",
    d: "M.417,0H24.583A.417.417,0,0,1,25,.417v10.1a.417.417,0,0,1-.417.417H.417A.417.417,0,0,1,0,10.521V.417A.417.417,0,0,1,.417,0Z",
    transform: "translate(-19335 -20721.072)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7130",
    "data-name": "Path 7130",
    className: "cls-1",
    d: "M64.819,48.907a.781.781,0,1,0,.552.229A.776.776,0,0,0,64.819,48.907Z",
    transform: "translate(-19378.727 -20765.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7133",
    "data-name": "Path 7133",
    className: "cls-1",
    d: "M64.819,48.907a.781.781,0,1,0,.552.229A.776.776,0,0,0,64.819,48.907Z",
    transform: "translate(-19383.414 -20765.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7134",
    "data-name": "Path 7134",
    className: "cls-1",
    d: "M64.819,48.907a.781.781,0,1,0,.552.229A.776.776,0,0,0,64.819,48.907Z",
    transform: "translate(-19388.102 -20765.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7135",
    "data-name": "Path 7135",
    className: "cls-2",
    d: "M-21048.227-23996.766v1.563",
    transform: "translate(1719.904 3280.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7136",
    "data-name": "Path 7136",
    className: "cls-2",
    d: "M-21048.227-23996.766v1.563",
    transform: "translate(1716.779 3280.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7138",
    "data-name": "Path 7138",
    className: "cls-1",
    d: "M-22637-21400.057l4.191-7.215h16.609l4.2,7.215",
    transform: "translate(3302 679.27)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObWhite);
export default __webpack_public_path__ + "static/media/obWhite.6ea5c4af12e388c789dbe9474cc0da59.svg";
export { ForwardRef as ReactComponent };